import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DuplicateOrderDialogData {
    orders: any[];
    answer?: string;
}

@Component({
    selector: 'phscw-popup-duplicate-order',
    templateUrl: './popup-duplicate-order.component.html',
    styleUrls: ['./popup-duplicate-order.component.scss'],
    standalone: false,
})
export class PopupDuplicateOrderComponent {
    constructor(
        public dialogRef: MatDialogRef<PopupDuplicateOrderComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DuplicateOrderDialogData,
    ) {
        dialogRef.disableClose = true;
    }

    formatDate(dateValue: any): string {
        if (!dateValue) return '';
        return new Date(dateValue).toLocaleDateString('de-DE');
    }

    formatCurrency(value: any): string {
        if (value == null) return '';
        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) return '';
        return num.toLocaleString('de-DE', {style: 'currency', currency: 'EUR'});
    }

    getEmployeeName(order: any): string {
        if (order.employee) {
            return `${order.employee.firstname} ${order.employee.lastname}`;
        }
        return '';
    }

    getStatusLabel(status: string): string {
        switch (status) {
            case '1': return 'Neu';
            case '2': return 'Gesendet';
            case '3': return 'Freigegeben';
            default: return status ?? '';
        }
    }

    clickAndClose(answer: string): void {
        this.data.answer = answer;
        this.dialogRef.close(this.data);
    }
}
